// Import necessary action types, HttpService, and Post function
import {
  AllViewCount_FETCH_DATA_SUCCESS,
  AllViewCount_HAVE_ERROR,
  AllViewCount_ARE_LOADING,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Post } from "../../services/api.service";

// Action creator function to handle different types of post actions
export function AllViewCountAction(action, payload) {
  switch (action) {
    case AllViewCount_HAVE_ERROR:
      // Return action object indicating error
      return {
        type: action,
        hasError: payload,
      };

    case AllViewCount_ARE_LOADING:
      // Return action object indicating loading state and resetting Post data to null
      return {
        type: action,
        isLoading: payload,
        Post: null,
      };

    case AllViewCount_FETCH_DATA_SUCCESS:
      // Return action object containing fetched post data
      return {
        type: action,
        Post: payload,
      };

    default:
      return;
  }
}

// Async action creator function to fetch post data based on provided URL
export function AllViewCountActionFetchData(url) {
  return (dispatch) => {
    // Dispatch action to indicate data loading
    dispatch(AllViewCountAction(AllViewCount_ARE_LOADING, true));

    // Make a POST request to fetch post data based on provided URL
    return Post(HttpService.AllViewCount, { url: url })
      .then((result) => {
        // Dispatch success action with fetched post data
        dispatch(AllViewCountAction(AllViewCount_FETCH_DATA_SUCCESS, result.data));
        // Resolve the promise with the result
        return result;
      })
      .catch((error) => {
        // Dispatch error action if request fails and reject the promise
        dispatch(AllViewCountAction(AllViewCount_HAVE_ERROR, true));
        return Promise.reject(error);
      });
  };
}
